import ClientUtils from '../utils/http-clients';
import Settings from '../resources/settings';

const baseUrl = Settings.API_BASE_PATH + '/reporting-api/v3/reporting-api';

export const getSchoolsURI = (partnerBid) => `${baseUrl}/partners/${partnerBid}/schools`;

export default {
  getDataExportHistory: (partnerBid, educatorBid, config) => {
    const url = `${baseUrl}/partners/${partnerBid}/educators/${educatorBid}/data-export-history`;

    return ClientUtils.makeGetRequest(url, config);
  },

  getUserLicenses: (partnerBid, config) => {
    const url = `${baseUrl}/partners/${partnerBid}/licenses`;

    return ClientUtils.makeGetRequest(url, config);
  },
};
